import React, { useEffect } from 'react';
import css from './SignupModal.module.css';
import OfferSection from '../OfferSection/OfferSection';
import NamedLink from '../NamedLink/NamedLink';
import useMedian from '../../hooks/useMedian';

const SignupModal = ({ onClose, userLoggedIn }) => {
  const { isMedian } = useMedian();
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className={css.modalOverlay}>
      <div className={css.modalContent}>
        <div className={css.modalContentText}>
          <button className={css.closeBtn} onClick={onClose}>
            ×
          </button>
          <h2>Welcome to Purfurry!</h2>

          {!userLoggedIn && (
            <>
              <p>Sign up now to explore personalized pet care options.</p>
              <button
                className={css.signupBtn}
                onClick={() => (window.location.href = '/signup/customer')}
              >
                Sign Up
              </button>

              <div>
                Want to signup as a <b>Provider</b>?
                <button
                  className={css.signupBtnProvider}
                  onClick={() => (window.location.href = '/signup/provider')}
                >
                  Click here
                </button>
              </div>
            </>
          )}
          {/* <div style={{marginTop: "10px"}}>Our <NamedLink name="CMSPage" params={{pageId: 'terms-and-conditions'}}>Terms and Conditions</NamedLink> have been updated on Feb 7, 2026.</div> */}
        </div>
        {/* //only show for website */}
        {!isMedian && <OfferSection />}
      </div>
    </div>
  );
};

export default SignupModal;
